import  { useState } from 'react';
import { useNavigate } from "react-router-dom";

import MessageInfoBox, {MessageErreurApi} from '../../Components/Messages.jsx';
import LoadingSpinner from "../../Components/LoadingSpinner";
import ButtonDeBase from '../../Components/ButtonsCustom.jsx';

import { apiGetProprietesFree, apiSoumissionFormulaireDemande } from '../../Datas/datasAutre.js'

const OrganismeListe = ({organismes, setOrganismes, resetForm}) => {
  const navigate = useNavigate();

  const [dataLoaded, setDataLoaded] = useState(true);
  const [spinnerLoad, setSpinnerLoad] = useState(false);
  const [messageProbleme, setMessageProbleme] = useState();

  const supprimerOrganisme = (index) => {
    const copie = [...organismes];
    copie.splice(index, 1);
    setOrganismes(copie);
  };

  const soumetDonneesPourEnregistrement = async () => {
      try {        
        setMessageProbleme();
        setDataLoaded(false);  
  
        setSpinnerLoad(true);
        var dataR = await apiSoumissionFormulaireDemande("", organismes, "creation-compte");
        setSpinnerLoad(false);  
        setDataLoaded(true);
        
        if(global.config.modeDebugApp == 1) console.log('retour apiSoumissionFormulaireDemande : ', dataR);
  
        switch (dataR.statusCode) {
            case 200:                 
                alert("Votre demande a bien été transmise, nous vérifions l'ensemble des éléments communiqués et revenons vers vous dans les plus brefs délais.");
                navigate('/');
                //resetForm(); // Réinitialise le formulaire
                //setOrganismes([]); // Réinitialise la liste des organismes

                break;
            case 401:
                setMessageProbleme(global.config.msgPrTechnique.msgUnauthorized); // Problème technique Unauthorized
                break;
            default:
                setMessageProbleme(global.config.msgPrTechnique.msgDefaut); // Problème technique par défaut
        }             
      } catch (err) {
        console.error(err);
        alert("Erreur réseau Liste.");
      }
    };
  
  return (  
    <>
      <LoadingSpinner dataLoaded={!spinnerLoad} message="Envoie des informations..."  className="spinner-container3"/>
      <MessageErreurApi message={messageProbleme} />

      {organismes.length > 0 && (
        <div style={{ marginTop: 10 }}>
            {organismes.length > 1 && 
            <ButtonDeBase typeSubmit={false} onClick={soumetDonneesPourEnregistrement} lib="Envoyer ma demande" 
                          disabled={dataLoaded == true ? false : true} className2="myside" />
            }

            {organismes.map((org, index) => (

                <div
                key={index}
                style={{
                    border: '1px solid #ccc',
                    padding: '15px',
                    marginBottom: '10px',
                    borderRadius: '5px',
                }}
                >

                  { org.OrganismePrincipal == true &&
                    <b>Organisme principal<br /></b>           
                  }
                  <strong>{org.RaisonSociale}</strong>- {org.Siret}<br />

                  {org.Uai != "" && <>UAI : {org.Uai}<br /></>}   
                  {org.NumDe != "" && <>Numéro de déclaration d'activité : {org.NumDe} (Date de la dernière déclaration : {org.DateDerniereDeclaration})<br /></>}
                  {org.Code_ape != "" && <>Code APE : {org.Code_ape}<br /></>}
                  {org.Date_creation != "" && <>Date de création : {org.Date_creation}<br /></>}  
                  {org.Email != "" && <>Email : {org.Email}<br /></>}

                  {org.Sigle} {org.Adresse1} {org.Codepostal} {org.Commune}<br />

                  {org.OrgTelPortable != "" && <>Téléphone portable : {org.OrgTelPortable}<br /></>}
                  {org.OrgTelFixe != "" && <>Téléphone fixe : {org.OrgTelFixe}<br /></>}
                  {org.SiteWeb != "" && <>Site web : <a href={org.SiteWeb} target="_blank" rel="noopener noreferrer">{org.SiteWeb}</a><br /></>}  

                  {org.QuiformeEstlaSource == true?
                    <p>Source Quiforme</p> : <p>Source OF</p> 
                  }

                  {org.NomReferent != "" &&
                    <>Réferent : {org.NomReferent} {org.PrenomReferent}<br /></>
                  }

                  Responsable : {org.ResponsablePrenom} {org.ResponsableMail} {org.ResponsableTelFixe} {org.ResponsableTelPortable}<br />


                  {org.LieuDenomination != "" &&
                  <>Lieu : {org.LieuDenomination} {org.LieuAdresse1} {org.LieuAdresse2} {org.LieuVilleId} {org.LieuVilleLib} {org.LieuMail} {org.LieuTelFixe} {org.LieuTelPortable} {org.LieuSiteWeb}<br /></>
                  }

                  { org.OrganismePrincipal == false &&
                    <button
                        onClick={() => supprimerOrganisme(index)}
                        style={{ marginTop: 10, background: 'red', color: 'white' }}
                    >Supprimer</button>              
                  }

                </div>
            ))}

          {/*
          <ul>
            {organismes.map((org, index) => (
              <li key={index}>
                {org.RaisonSociale} – {org.NomReferent} {org.PrenomReferent} -
                 {org.LieuAdresse1} -          {org.email} -          {org.NomReferent}
              </li>
            ))}
          </ul>*/}
        </div>
      )}
    </>
  );
};

export default OrganismeListe;